require('./bootstrap');
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import MainApp from './components/MainApp.vue';
import { routes } from './router.js';
import StoreData from './store.js';
import ElementUI from 'element-ui';
import { initialize } from './helpers/general';
import vueHeadful from 'vue-headful';
import moment from 'moment';

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)
import VueDataTables from 'vue-data-tables'
Vue.use(VueDataTables)
Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('MMM DD, YYYY');
    }
});
Vue.filter('upper', function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
})

Vue.component('vue-headful', vueHeadful);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(ElementUI);

const store = new Vuex.Store(StoreData);
const router = new VueRouter({
    routes,
    mode: 'history'
});

initialize(store, router);
router.beforeEach((to, from, next) => {
    store.commit('updateFrontAppSlug', to);
    next();
});
const app = new Vue({
    el: '#app',
    router, store,
    components: { MainApp }
});